import type { PetitionActionsPageState } from './types';

export const INITIAL_STATE: PetitionActionsPageState = {
	endCursor: undefined,
	supporterVoices: [],
	isLastSupporterVoicesPage: true,
	isLoadingMoreSupporterVoices: false,
	newSupporterVoiceId: undefined,
	shareSupporterVoiceError: undefined,
	shareSupporterVoiceSuccess: false,
	shouldDisplaySupporterVoicesVideo: false,
	unlikeErrors: {},
	likeErrors: {},
};
